import { FC } from 'react';

import { CodeV2 as Code } from '@/redux/apis/codes-api';
import { QrCodeChart } from './linear-chart/chart';
import { ChartProvider } from './linear-chart/context';
import { ChartFilters } from './linear-chart/filters';

export const QRCodeLinearChart: FC<{ code: Code }> = ({ code }) => (
  <ChartProvider>
    <div className="flex flex-col gap-4">
      <ChartFilters />
    </div>

    <div className="mt-[20px]">
      <QrCodeChart code={code} />
    </div>
  </ChartProvider>
);
